<div class="p-3">
  <form [formGroup]="themeForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <!-- Theme Title -->
      <div class="col-md-12 mb-3">
        <label for="title" class="form-label">
          {{ 'ADMIN.THEME_TITLE' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" id="title" formControlName="title"
          [class.is-invalid]="isFieldInvalid('title')" [placeholder]="'ADMIN.ENTER_THEME_TITLE' | translate" />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('title')">
          {{ getErrorMessage('title') }}
        </div>
      </div>

      <!-- Theme Description -->
      <div class="col-md-12 mb-3">
        <label for="description" class="form-label">
          {{ 'ADMIN.THEME_DESCRIPTION' | translate }}
          <span class="text-danger">*</span>
        </label>
        <textarea class="form-control" id="description" formControlName="description" rows="4"
          [class.is-invalid]="isFieldInvalid('description')"
          [placeholder]="'ADMIN.ENTER_THEME_DESCRIPTION' | translate"></textarea>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
          {{ getErrorMessage('description') }}
        </div>
      </div>

      <!-- Matière : choisie ici, pas héritée du filtre de la liste -->
      <div class="col-md-12 mb-3">
        <label for="subjectId" class="form-label">
          {{ 'DATA_TABLE.SUBJECT' | translate }}
          <span class="text-danger">*</span>
        </label>
        <app-custom-select
          [options]="subjectOptions"
          [allowAdd]="false"
          [inputId]="'subjectId'"
          [placeholderText]="'ADMIN.SELECT_SUBJECT' | translate"
          [triggerClass]="'select-trigger form-select'"
          [showError]="isFieldInvalid('subjectId')"
          [errorMessage]="getErrorMessage('subjectId')"
          formControlName="subjectId">
        </app-custom-select>
      </div>

      <!-- Display Order -->
      <div class="col-md-6 mb-3">
        <label for="displayOrder" class="form-label">
          {{ 'ADMIN.DISPLAY_ORDER' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input type="number" class="form-control" id="displayOrder" formControlName="displayOrder"
          [class.is-invalid]="isFieldInvalid('displayOrder')" min="0" />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('displayOrder')">
          {{ getErrorMessage('displayOrder') }}
        </div>
      </div>

      <!-- Is Active -->
      <div class="col-md-6 mb-3">
        <label class="form-label d-block">
          {{ 'ADMIN.STATUS' | translate }}
        </label>
        <div class="form-check form-switch mt-2">
          <input class="form-check-input" type="checkbox" role="switch" id="isActive" formControlName="isActive" />
          <label class="form-check-label" for="isActive">
            {{ (isActive?.value ? 'ADMIN.ACTIVE' : 'ADMIN.INACTIVE') | translate }}
          </label>
        </div>
      </div>
    </div>

    <!-- Form Actions -->
    <div class="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
      <button type="button" class="btn btn-secondary px-4" (click)="onCancel()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="submit" class="btn btn-primary px-4" [disabled]="themeForm.invalid">
        <i class="fa-solid fa-floppy-disk me-2"></i>
        {{ (isEditMode ? 'COMMON.UPDATE' : 'COMMON.SAVE') | translate }}
      </button>
    </div>
  </form>
</div>